"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.replace");

require("core-js/modules/es.string.split");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.renderBmDynamicLabelItem = exports.registerBmDynamicLabelElement = exports.BmDynamicLabelElement = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));

var _element = require("@blue/element");

var _mask = require("@blue/services/utils/mask");

var _staticLabel = require("../static-label");

var _itemRenderer = require("../../../../core/render/items/item-engine/item-renderer");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)([" <bm-dynamic-label-element .info=\"", "\"></bm-dynamic-label-element> "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)([""]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BmDynamicLabelElement = /*#__PURE__*/function (_BmItemElement) {
  (0, _inherits2.default)(BmDynamicLabelElement, _BmItemElement);

  var _super = (0, _createSuper2.default)(BmDynamicLabelElement);

  function BmDynamicLabelElement() {
    (0, _classCallCheck2.default)(this, BmDynamicLabelElement);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BmDynamicLabelElement, [{
    key: "render",
    value: function render() {
      var staticLabelInfo = this.makeStaticLabelInfo(this.info);
      return (0, _staticLabel.renderBmStaticLabelItem)(staticLabelInfo);
    }
  }, {
    key: "makeStaticLabelInfo",
    value: function makeStaticLabelInfo(info) {
      var label = this._interpolateLabel(info);

      return new _staticLabel.BmStaticLabelInfo((0, _objectSpread2.default)((0, _objectSpread2.default)({}, info), {}, {
        type: 'static-label',
        options: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, info.options), {}, {
          label: label
        })
      }), info.parent);
    }
  }, {
    key: "_interpolateLabel",
    value: function _interpolateLabel(info) {
      var label;

      if (info.value) {
        if (info.options.mask) {
          var maskFn = this._makeMaskFn(info.options.mask, info.value);

          label = maskFn(info.value.toString());
        } else {
          label = info.value;
        }
      } else {
        label = '- - -';
      }

      return label;
    }
  }, {
    key: "_makeMaskFn",
    value: function _makeMaskFn(maskOptions, value) {
      var mask = [];

      if (maskOptions.type === 'static') {
        var deserializedMask = maskOptions.options;
        mask = (0, _mask.deserialize)(deserializedMask);
      } else if (maskOptions.type === 'numeric') {
        var formatter = this._makeFormatter(maskOptions);

        mask = this._makeMask(formatter, value);
      }

      return (0, _mask.createMask)(mask).mask;
    }
  }, {
    key: "_makeFormatter",
    value: function _makeFormatter(maskOptions) {
      var _maskOptions$options = maskOptions.options,
          locale = _maskOptions$options.locale,
          style = _maskOptions$options.style,
          currency = _maskOptions$options.currency,
          format = (0, _objectWithoutProperties2.default)(_maskOptions$options, ["locale", "style", "currency"]);
      var _locale = Intl.NumberFormat.supportedLocalesOf(locale)[0];
      var formatOptions = (0, _objectSpread2.default)({
        style: style,
        currency: style === 'currency' ? currency : undefined
      }, format);
      return new Intl.NumberFormat(_locale, formatOptions);
    }
  }, {
    key: "_makeMask",
    value: function _makeMask(formatter, val) {
      var _val = val || 0;

      var parts = formatter.formatToParts(_val);
      var mask = (0, _reduce.default)(parts).call(parts, function (acc, part) {
        var vals;

        switch (part.type) {
          case 'fraction':
          case 'integer':
            {
              var _context;

              vals = (0, _map.default)(_context = part.value.split('')).call(_context, function () {
                return new RegExp(/\d/);
              });
              break;
            }

          case 'decimal':
            vals = new RegExp("\\".concat(part.value));
            break;

          default:
            vals = part.value.replace(/\s/, ' ');
            break;
        }

        return (0, _concat.default)(acc).call(acc, vals);
      }, []);
      if (formatter.resolvedOptions().minimumFractionDigits > 0) mask.push(/0/);
      return mask;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-dynamic-label-element';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        info: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject());
    }
  }]);
  return BmDynamicLabelElement;
}(_itemRenderer.BmItemElement);

exports.BmDynamicLabelElement = BmDynamicLabelElement;

var registerBmDynamicLabelElement = function registerBmDynamicLabelElement() {
  (0, _element.register)(BmDynamicLabelElement);
  (0, _staticLabel.registerStaticLabelElement)();
};

exports.registerBmDynamicLabelElement = registerBmDynamicLabelElement;

var renderBmDynamicLabelItem = function renderBmDynamicLabelItem(info) {
  return (0, _element.html)(_templateObject2(), info);
};

exports.renderBmDynamicLabelItem = renderBmDynamicLabelItem;
